module.exports = __webpack_public_path__ + "img/eigenvalues_graph_energy.26cb9a4d.svg";